module.exports = "../dist/frontend/icons/ui/select-arrow.svg?0cd8111a212943c059719c01716d93d6";